import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

const MarqueeBar = () => {
  const { t } = useLang();
  return (
    <div className="border-y border-border bg-secondary py-6" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {t.marquee.map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-heading text-2xl font-medium text-white/90 lg:text-3xl">
            {w}
            <span className="h-1.5 w-1.5 rounded-full bg-accent" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeBar;
